/**
 * Точка на фото в кадре галереи с обрезкой (fd-catalog-03).
 *
 * Продавец ставит точку на фото целиком (редактор кабинета показывает кадр
 * в пропорциях самого фото), координаты - проценты фото. Галерея карточки
 * показывает фото в кадре 560×728 с `object-fit: cover`: фото другой
 * пропорции обрезается по краям, и проценты фото перестают совпадать с
 * процентами кадра. Пересчитываем: где точка окажется в кадре после обрезки.
 * Точка в обрезанной части не видна - null.
 */
export const coverPinPosition = (
	pin: { x: number; y: number },
	imageRatio: number,
	frameRatio: number,
): { x: number; y: number } | null => {
	if (!(imageRatio > 0) || !(frameRatio > 0)) return { x: pin.x, y: pin.y };
	let x = pin.x / 100;
	let y = pin.y / 100;
	if (imageRatio > frameRatio) {
		// Фото шире кадра: по высоте впритык, лишнее срезано слева и справа.
		const scale = imageRatio / frameRatio;
		x = 0.5 - scale / 2 + x * scale;
	} else if (imageRatio < frameRatio) {
		// Фото выше кадра: по ширине впритык, срезано сверху и снизу.
		const scale = frameRatio / imageRatio;
		y = 0.5 - scale / 2 + y * scale;
	}
	if (x < 0 || x > 1 || y < 0 || y > 1) return null;
	return { x: Math.round(x * 10000) / 100, y: Math.round(y * 10000) / 100 };
};
